$(document).ready(function() {
    
    $('.js-full').on('click', function() {
        $('.b-modal-full-screen').addClass('show');
        $('body').addClass('fixed');
    });

    $('.js-full-close').on('click', function() {
        $('.b-modal-full-screen').removeClass('show');
        $('body').removeClass('fixed');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/promo/modal-full-screen.js